import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import xt from "./custom-event-data.js";
import Mt from "./custom-event-property-data.js";
import Bt from "./filter-set.js";
import Kt from "./in-app-message-click-data.js";
import Qt from "./purchase-data.js";
import Vt from "./purchase-property-data.js";
import Wt from "./push-click-data.js";
import V from "./trigger-events.js";
import r from "../../../shared-lib/braze-shared-lib.js";

var Gt = /*#__PURE__*/function () {
  function Gt(e, t) {
    _classCallCheck(this, Gt);

    this.type = e, this.data = t;
  }

  _createClass(Gt, [{
    key: "qa",
    value: function qa(e, t) {
      return Gt.$a[this.type] === e && (null == this.data || this.data.Ql(t));
    }
  }, {
    key: "ss",
    value: function ss() {
      return {
        t: this.type,
        d: this.data ? this.data.ss() : null
      };
    }
  }], [{
    key: "au",
    value: function au(e, t) {
      var a = null;

      try {
        a = window.atob(e);
      } catch (t) {
        return r.D.info("Failed to unencode analytics id " + e + ": " + t.message), !1;
      }

      return t === a.split("_")[0];
    }
  }, {
    key: "fromJson",
    value: function fromJson(e) {
      var t = e.type;
      var r;

      switch (t) {
        case Gt.ec.OPEN:
          r = null;
          break;

        case Gt.ec.Rr:
          r = Qt.fromJson(e.data);
          break;

        case Gt.ec.tc:
          r = Vt.fromJson(e.data);
          break;

        case Gt.ec.vr:
          r = Wt.fromJson(e.data);
          break;

        case Gt.ec.be:
          r = xt.fromJson(e.data);
          break;

        case Gt.ec.rc:
          r = Mt.fromJson(e.data);
          break;

        case Gt.ec.Ar:
          r = Kt.fromJson(e.data);
          break;

        case Gt.ec.ks:
          r = null;
      }

      return new Gt(t, r);
    }
  }, {
    key: "yn",
    value: function yn(e) {
      var t, r;

      switch (e.t) {
        case Gt.ec.OPEN:
          t = null;
          break;

        case Gt.ec.Rr:
          t = new Qt(e.d);
          break;

        case Gt.ec.tc:
          r = e.d || {}, t = new Vt(r.id, Bt.yn(r.pf || []));
          break;

        case Gt.ec.vr:
          t = new Wt(e.d);
          break;

        case Gt.ec.be:
          t = new xt(e.d);
          break;

        case Gt.ec.rc:
          r = e.d || {}, t = new Mt(r.e, Bt.yn(r.pf || []));
          break;

        case Gt.ec.Ar:
          t = new Kt(e.d);
          break;

        case Gt.ec.ks:
          t = null;
      }

      return new Gt(e.t, t);
    }
  }]);

  return Gt;
}();

export { Gt as default };
Gt.ec = {
  OPEN: "open",
  Rr: "purchase",
  tc: "purchase_property",
  vr: "push_click",
  be: "custom_event",
  rc: "custom_event_property",
  Ar: "iam_click",
  ks: "test"
}, Gt.$a = {}, Gt.$a[Gt.ec.OPEN] = V.OPEN, Gt.$a[Gt.ec.Rr] = V.Rr, Gt.$a[Gt.ec.tc] = V.Rr, Gt.$a[Gt.ec.vr] = V.vr, Gt.$a[Gt.ec.be] = V.be, Gt.$a[Gt.ec.rc] = V.be, Gt.$a[Gt.ec.Ar] = V.Ar, Gt.$a[Gt.ec.ks] = V.ks;